import { Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next';
import { useEffect, useState } from 'react';
import { useAllContext } from '../../context/AllContext';
import axios from 'axios';
import { toast } from 'react-toastify';

const SelectEvents = () => {
    const { t } = useTranslation();
    const { GetAllInterestedEvent, allInterestedEvent } = useAllContext()

    const navigate = useNavigate()
    const registerData = JSON.parse(localStorage.getItem('registerData')) || {};
    
    const [errors, setErrors] = useState({});
    const [inputValue, setInputValue] = useState({
        events: []
    });

    const inputHandler = (e) => {
        const { value, checked } = e.target;

        setInputValue((prev) => {
            let updatedEvents = prev.events || [];

            if (checked) {
                updatedEvents = [...updatedEvents, value];
            } else {
                updatedEvents = updatedEvents.filter((v) => v !== value);
            }

            return {
            ...prev,
            events: updatedEvents
            };
        });
    };

    const validate = () => {
        let errors = {};

        if (inputValue.events.length === 0) {
            errors.events = "Please Select Event"
        }

        return errors;
    };

    const submitForm = async (e) => {
        e.preventDefault()

        const formErrors = validate();
        setErrors(formErrors);

        const apiData = {
            userID: registerData?.userId,
            parent_age: registerData?.birthDate,
            child_age: registerData?.childBirthDate,
            event_interests: inputValue.events,
            type: registerData.loginStatus !== "login" ? registerData?.userType : ""
        }
        
        if (Object.keys(formErrors).length === 0) {
            try {
                const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/register-now`, apiData)
                const data = await response.data
                
                const userData = {
                    _id: data?.user?._id,
                    username: data?.user?.username,
                    email: data?.user?.email,
                    profileImage: data?.user?.profileImage,
                    type : data?.user?.type,
                    token: data?.token
                }
                
                if(data.status === 1){
                    localStorage.setItem('limitsUser', JSON.stringify(userData))
                    toast.success(data.message)
                    localStorage.removeItem('registerData')
                    navigate('/')
                } else {
                    toast.error(data.message)
                    navigate('/park/signup')
                }
            } catch (error) {
                console.log('Error:', error);
            }
        }
    }

    useEffect(() => {
        GetAllInterestedEvent()
    }, []);

    return (
        <>
            <div className="light-theme">
                <div className='main-content'>
                    <div className='padding login-section'>
                        <div className='container'>
                            <div className='login-box mx-auto'>
                                <h4 className='text-center mb-1'>{t('Interested in attending events?')}</h4>
                                <p className='text-center mb-5'>{t('Please Select Interests Below')}</p>

                                <form className='form form1' onSubmit={submitForm}>
                                    <div className="">
                                        {
                                            allInterestedEvent?.length > 0 && allInterestedEvent.map((items) => {
                                                return <div key={items._id} className='mb-3'>
                                                    <div className="form-check event">
                                                        <label className="form-check-label" htmlFor={items._id}>
                                                            <input className="form-check-input" 
                                                            type="checkbox" 
                                                            id={items._id} 
                                                            name="inPerson"
                                                            value={items._id}
                                                            onChange={inputHandler} /> 
                                                            {items.name}
                                                        </label>
                                                    </div>
                                                </div>
                                            })
                                        }
                                        
                                        <div>
                                            {errors.events && <p className="error-text">{errors.events}</p>}
                                        </div>

                                    </div>
                                    
                                    {
                                        inputValue.events.length > 0 && <div className='mt-4 text-center'>
                                            <h4 className='mb-0'>We look forward to sharing amazing experiences with you!</h4>
                                        </div>
                                    }

                                    <div className='mt-4'>
                                        <button type='submit' className='btn btn1 w-100 mt-4'>{t('NEXT')}</button>
                                    </div>
                                </form>

                                <p className='mb-0 text-center mt-5'>{t('Already have an account? Login')} <span className='text-black'><Link to="/park/signin" className='link text-decoration-underline fw-medium'>Login</Link></span></p>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SelectEvents
